/**
 * @param {number} rate
 * @param {string} code
 * @returns {string}
*/
export const getFormattedCurrencyRate = (rate, code) => {
    if (['EUR/USD', 'USD/EUR'].includes(code)) {
        return String(rate.toFixed(4));
    }

    return `${rate.toFixed(2)}&nbsp;&#8381;`;
};
